import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Children, cloneElement } from 'react';
import { useOccConfig } from '../../../../context/occ/hooks/use-occ-config';
import { HelpText } from '../../help-text/help-text';
import { getHelpTextId } from '../../help-text/utils/get-help-text-id';
import { Label, LabelType } from '../../label';
const b = bemClassBuilder('v-field');
/**
 * Renders a field that wraps an input element, optional label and optional help text.
 * Passes the ID, name and style down to children elements and associates the label and help text to the input element.
 * Note: You should use a Fieldset for Checkbox Groups and Radio Groups, and use Field for all other input types.
 */
export const Field = observer(props => {
    const { form: formConfig } = useOccConfig();
    const { id, name, label, optional, helpText, style, children, className, hideOptionalSuffixLabel } = props;
    const showLabel = props.showLabel !== false && !!label;
    const helpTextId = getHelpTextId(id);
    const inputProps = {
        id,
        name,
        style,
        helpTextId: helpText ? helpTextId : undefined,
        label: !showLabel ? label : undefined,
        children: showLabel ? inputLabel(id, label, optional, style, hideOptionalSuffixLabel) : undefined
    };
    const inputChildrenWithExtraProps = children
        ? Children.map(children, child => cloneElement(child, Object.assign(Object.assign({}, inputProps), { 
            // Allows external help text where helpTextId is set directly in Input.
            helpTextId: child.props.helpTextId || inputProps.helpTextId })))
        : [];
    return (_jsxs("div", { className: b.block({ floatingLabel: formConfig.enableFloatingInputLabels && showLabel }, className), children: [inputChildrenWithExtraProps, !!helpText && _jsx(HelpText, { id: helpTextId, style: style, text: helpText })] }));
});
Field.displayName = 'Field';
const inputLabel = (id, label, optional, style, hideOptionalSuffixLabel) => {
    return (_jsx(Label, { text: label, type: LabelType.Label, elementId: id, optional: optional && !hideOptionalSuffixLabel, style: style }));
};
//# sourceMappingURL=field.js.map